var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"88b68e73a36a92911873d1294bee5d21992c0b63"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["metalmax@elementar-digital"]={id:"88b68e73a36a92911873d1294bee5d21992c0b63"};
      